import RepeatIcon from 'components/material-symbol/icons/Repeat'
import TrendingUpIcon from 'components/material-symbol/icons/TrendingUp'
import AccessTimeIcon from 'components/material-symbol/icons/AccessTime'
import AppsIcon from 'components/material-symbol/icons/Apps'
import AttachMoneyIcon from 'components/material-symbol/icons/AttachMoney'

export const METRIC_ICONS = {
  'first-to-second-conversion': RepeatIcon,
  'rebooking-rate': TrendingUpIcon,
  'response-time': AccessTimeIcon,
  'booking-offering-mix': AppsIcon,
  pricing: AttachMoneyIcon,
}

export const getMetricIcon = metricId => METRIC_ICONS[metricId] || null
